import { Stack } from "@mui/material";
import { useState } from "react";
import { WifiKeyDto } from "../../dtos/WifiKeyDto";
import { WifiDetails } from "./WifiDetails";
import { EnterVisitorDetails } from "./EnterVisitorDetails";


export const VisitorWifiKey : React.FC = ( ) => {

    const [ wifiKey, setWifiKey ] = useState< WifiKeyDto >( );

    const handleSetWifiKey = ( wifiKeyDto : WifiKeyDto | undefined ) => {

        setWifiKey( wifiKeyDto );

    };

    return(

        <Stack justifyContent="center" spacing={2} sx={{ alignItems :"center" }}>

            <EnterVisitorDetails onSetWifiKey={ handleSetWifiKey } />

            { wifiKey  && <WifiDetails wifiKeyDto={ wifiKey } /> }

        </Stack>

    );

};